module.exports = __webpack_public_path__ + "img/hr-tree-07-d-trunk.cc47d8da.png";